<template>    
    <div>        
        <b-row>        
            <b-col style="margin-left: 10px;margin-right: 10px;">
                <Table
                    id="documento_table"
                    primaryKey="id"
                    :items="documentos"
                    :fields="fields"
                    :onRegistraPagamento="registrarPagamento"
                    :onShowDetail="carregaPagamentos">
                </Table>
                <b-card>
                    <b-card-text>
                        Total do Documento: {{ this.totalDocumento.toLocaleString('pt-BR', { minimumFractionDigits: 2}) }} | 
                        Soma dos depósitos: {{ this.totalUtilizar.toLocaleString('pt-BR', { minimumFractionDigits: 2}) }} | 
                        Saldo Restante: {{ this.totalDevedor.toLocaleString('pt-BR', { minimumFractionDigits: 2}) }}
                    </b-card-text>
                </b-card>
            </b-col>
            <div>            
                <b-sidebar id="sidebar_pagamento" title="Registrar Pagamento" right shadow v-model="isSidebarOpen">
                    <b-row>
                        <b-card>
                            <b-card-text>
                                <b-col style="margin-left: 10px;margin-right: 10px;">
                                    <b-row cols="12" style="margin-left: 5px;margin-right: 5px">
                                        <b-col sm="12" md="12" lg="12" xl="12">
                                            <label>Documento: {{ documento.NR_DOC }} / {{ documento.PARCELA }}</label>
                                        </b-col>
                                        <b-col sm="12" md="12" lg="12" xl="12">
                                            <label>Venc:  {{ new Date(documento.VENCIMENTO).toLocaleDateString('pt-br') }}  </label>
                                            <label style="padding-left: 50px;">Valor:  R$ {{ documento.VALOR_DOC.toLocaleString('pt-BR', { minimumFractionDigits: 2}) }}</label>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-card-text>
                        </b-card>                    
                    </b-row>
                    <b-row cols="12" style="margin-left: 5px;margin-right: 5px">
                        <b-col sm="12" md="12" lg="12" xl="12">
                            <label>Data Pagamento *</label>
                            <inputData
                                id="pagamento_dt_deposito"
                                v-model="pagamento.DT_DEPOSITO"
                                :customClass="'form-control'">
                            </inputData>
                        </b-col>
                        <b-col sm="12" md="12" lg="12" xl="12">
                            <label>Nome do Depositante *</label>
                            <b-input
                                v-model="pagamento.NOME_DEPOSITANTE"
                                :customClass="'form-control'">
                            </b-input>
                        </b-col>
                        <b-col sm="12" md="12" lg="12" xl="12">
                            <label>Valor do Depósito *</label>
                            <money
                                v-model="pagamento.VALOR_DEPOSITO"
                                v-bind="valorQuinzeDois"
                                v-bind:class="'form-control'"
                                id="pagamento_valor_deposito">
                            </money>
                        </b-col>
                        <b-col sm="12" md="12" lg="12" xl="12">
                            <label>Valor à Utilizar *</label>
                            <money
                                v-model="pagamento.VALOR_UTILIZAR"
                                v-bind="valorQuinzeDois"
                                v-bind:class="'form-control'"
                                id="pagamento_valor_utilizar">
                            </money>
                        </b-col>
                        <b-col sm="12" md="12" lg="12" xl="12" style="padding-top: 50px;">
                            <b-form-file
                                style="margin: 2px 6px 0px 0px"
                                browse-text= "Procurar"
                                accept=".jpg,.jpeg,.png,.pdf"
                                v-model="isFileSelected"
                                :state="Boolean(isFileSelected) ? true : null"
                                @change="selecionarArquivo"
                                placeholder="Anexar Comprovante"
                                drop-placeholder="Arraste o arquivo até aqui">
                            </b-form-file>
                        </b-col>
                        <b-col sm="12" md="12" lg="12" xl="12" style="padding-top: 15px;">
                            <b-button variant="info" @click="salvarPagamento">
                                <b-icon icon="upload"></b-icon>  Confirmar Pagamento
                            </b-button>
                        </b-col>
                    </b-row>
                </b-sidebar>
            </div>    
            <div>            
                <b-sidebar id="sidebar_pagamentos" title="Depósitos" right shadow v-model="isSidebarPagamentosOpen">
                    <Table
                        id="documento_pagamentos_table"
                        primaryKey="id"
                        :items="pagamentos"
                        :fields="fields_pagamento"
                        :onBaixarComprovante="baixarComprovante">
                    </Table>
                </b-sidebar>
            </div>
        </b-row>    
        <b-row cols="12" style="margin-left: 5px;margin-right: 5px;float:right">
            <b-button variant="warning" title="Atualizar" @click="listar()">
                <b-icon icon="arrow-repeat"></b-icon> Atualizar
            </b-button>  
        </b-row>    
    </div>
</template>

<script>
    import documentoServices from '@/services/Documento';
    import Table from '@/components/tables/PagamentoTable';
    import utilServices from "@/services/Util";
    import mascaras from "@/util/Mascaras";
    import inputData from '@/components/input/inputData.vue';
    import {Money} from 'v-money';
    import {valorQuinzeDois} from '@/util/vMoneySettings';

    export default {
        name: 'Documento',
        components: {
            Table,
            inputData,
            Money
        },
        data() {
            return {
                documentos: [],
                documento: {
                    CD_CLIENTE:0,
                    TIPO_DOC:0,
                    DATA_DOC:"",
                    VENCIMENTO:"",
                    NR_DOC:"000",
                    PARCELA:"000",
                    VALOR_DOC:0.00,
                    VALOR_DEPOSITO:0.00,
                    VALOR_UTILIZAR:0.00,
                    SALDO_DEVEDOR:0.00,
                    OBSERVACAO:""
                },
                fields: [
                    { key: 'NR_DOC', sortable: false, class: 'text-center', label: 'Número'},
                    { key: 'PARCELA', sortable: false, class: 'text-center', label: 'Parcela'},
                    { key: 'DATA_DOC', sortable: false, class: 'text-right', label: 'Dt. Emissão', formatter: (value, key, item) => {return mascaras.formataData(item.DATA_DOC, value);}},
                    { key: 'VENCIMENTO', sortable: false, class: 'text-right', label: 'Dt. Vencimento', formatter: (value, key, item) => {return mascaras.formataData(item.VENCIMENTO, value);}},
                    { key: 'VALOR_DOC', sortable: false, class: 'text-right', label: 'Valor Original', formatter: value => {return value.toLocaleString('pt-BR', { minimumFractionDigits: 2})}},
                    { key: 'VALOR_DEPOSITO', sortable: false, class: 'text-right', label: 'Valor Depósito', formatter: value => {return value.toLocaleString('pt-BR', { minimumFractionDigits: 2})}},
                    { key: 'VALOR_UTILIZAR', sortable: false, class: 'text-right', label: 'Valor Utilizado', formatter: value => {return value.toLocaleString('pt-BR', { minimumFractionDigits: 2})}},
                    { key: 'SALDO_DEVEDOR', sortable: false, class: 'text-right', label: 'Valor em Aberto', formatter: value => {return value.toLocaleString('pt-BR', { minimumFractionDigits: 2})}},
                    { key: 'actions', label: 'Ações', 'class': 'btn-actions'}
                ], 
                totalDocumento: 0.00,
                totalUtilizar: 0.00,
                totalDevedor: 0.00,
                isSidebarOpen: false,
                valorQuinzeDois: valorQuinzeDois,
                pagamento: {
                    CLIENTE: 0,
                    TIPO_DOC: 0,
                    NR_DOC: "",
                    PARCELA: "",
                    DT_DEPOSITO: "",
                    VALOR_DEPOSITO:0.00,
                    VALOR_UTILIZAR: 0.00,
                    NOME_DEPOSITANTE: ""
                },
                isFileSelected: null,
                file: null,
                comprovate: {
                    BASE64: ""
                },
                pagamentos: [],
                isSidebarPagamentosOpen: false,
                fields_pagamento: [
                    { key: 'ID', sortable: false, label: '#'},
                    { key: 'DT_DEPOSITO', sortable: false, class: 'text-right', label: 'Data', formatter: (value, key, item) => {return mascaras.formataData(item.DT_DEPOSITO, value);}},
                    { key: 'VALOR_DEPOSITO', sortable: false, class: 'text-right', label: 'Valor', formatter: value => {return value.toLocaleString('pt-BR', { minimumFractionDigits: 2})}},
                    { key: 'NOME_DEPOSITANTE', sortable: false, label: 'Responsável'},
                    { key: 'actions', label: 'Ações', 'class': 'btn-actions'}
                ], 
            }
        },
        mounted: function() {
            this.$insProgress.start();
            documentoServices.list()
            .then((response) => {
                let retorno = response.data;
                if (retorno['RET'] == "1") {
                    this.documentos = retorno['OBJ'];
                    this.totalizaValores();
                } else {
                    utilServices.parseServerError(retorno['OBJ'][0]['MSG'], this);
                }                
            })
            .catch((error) => {    
                utilServices.parseServerError(error, this);
            })
            .finally(() => {
                this.$insProgress.finish();
            });
        },
        methods: {
            registrarPagamento(item) {
                this.documento = item;
                
                this.pagamento.CLIENTE = this.documento.CD_CLIENTE;
                this.pagamento.TIPO_DOC = this.documento.TIPO_DOC;
                this.pagamento.NR_DOC = this.documento.NR_DOC;
                this.pagamento.PARCELA = this.documento.PARCELA;
                this.isSidebarOpen = true;
            },
            totalizaValores() {
                this.totalDocumento = 0.00;
                this.totalUtilizar = 0.00;
                this.totalDevedor = 0.00;

                for (let i = 0; i < this.documentos.length; i++) {
                    this.totalDocumento += this.documentos[i]['VALOR_DOC'];
                    this.totalUtilizar += this.documentos[i]['VALOR_UTILIZAR'];
                    this.totalDevedor += this.documentos[i]['SALDO_DEVEDOR'];
                }
            },
            salvarPagamento() {        
                if (this.isFileSelected == null) {
                    this.$bvToast.toast('Selecione o comprovante', {title: "Aviso", variant: "warning", solid: true,});
                } else {
                    let loader = this.$loading.show({});
                    documentoServices.registraPagamento(this.pagamento)
                    .then((response) => {
                        let retornoPagamento = response.data;
                        if (retornoPagamento['RET'] == 1) {
                            let idPagamento = retornoPagamento['OBJ'][0]['ID'];

                            this.createBase64Image(this.file);
                            documentoServices.enviaComprovante(idPagamento, this.comprovate, this.file.name.split('.').pop())
                            .then((response) => {
                                let retornoComprovante = response.data;
                                if (retornoComprovante['RET'] == 1) {
                                    this.$bvToast.toast('Registrado com sucesso', {title: "Sucesso", variant: "success", solid: true,});
                                } else
                                    this.$bvToast.toast(response.data.OBJ[0].MSG, {title: "Erro", variant: "danger", solid: true,});
                            })
                            .catch((error) => {
                                utilServices.parseServerError(error, this);
                            })
                            .finally(() => {
                            
                            });                        
                        } else
                            this.$bvToast.toast(response.data.OBJ[0].MSG, {title: "Erro", variant: "danger", solid: true,});
                    })
                    .catch((error) => {
                        utilServices.parseServerError(error, this);
                    })
                    .finally(() => {
                        loader.hide();
                        this.file = null;
                        this.isFileSelected = null;
                        this.base64 = "";
                        this.limparDados();
                        this.isSidebarOpen = false;
                        this.listar();
                    });
                }                     
            },
            selecionarArquivo(event){
                if(event.target.files){
                    this.file = event.target.files[0];
                }
            },
            createBase64Image: function(FileObject) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.comprovate.BASE64 = event.target.result.split(',')[1];
                }
                reader.readAsDataURL(FileObject);
            },
            limparDados() {
                this.documento = {
                    CD_CLIENTE:0,
                    TIPO_DOC:0,
                    DATA_DOC:"",
                    VENCIMENTO:"",
                    NR_DOC:"000",
                    PARCELA:"000",
                    VALOR_DOC:0.00,
                    VALOR_DEPOSITO:0.00,
                    VALOR_UTILIZAR:0.00,
                    SALDO_DEVEDOR:0.00,
                    OBSERVACAO:""
                };
                this.pagamento = {
                    CLIENTE: 0,
                    TIPO_DOC: 0,
                    NR_DOC: "",
                    PARCELA: "",
                    DT_DEPOSITO: "",
                    VALOR_DEPOSITO:0.00,
                    VALOR_UTILIZAR: 0.00,
                    NOME_DEPOSITANTE: ""
                };
            },
            carregaPagamentos(item) {
                this.documento = item;
                this.$insProgress.start();
                documentoServices.listPagamentos(this.documento.TIPO_DOC, this.documento.NR_DOC, this.documento.PARCELA)
                .then((response) => {
                    let retorno = response.data;
                    if (retorno['RET'] == "1") {
                        this.pagamentos = retorno['OBJ'];
                        this.isSidebarPagamentosOpen = true;
                    } else {
                        this.$bvToast.toast(retorno['OBJ'][0]['MSG'], {title: "Aviso", variant: "warning", solid: true,});
                    }                
                })
                .catch((error) => {    
                    console.log(error);
                    
                    utilServices.parseServerError(error, this);
                })
                .finally(() => {
                    this.$insProgress.finish();
                });
            },
            baixarComprovante(item) {
                let loader = this.$loading.show({});
                documentoServices.downloadComprovante(item['ID'])
                .then((response) => {
                    let retornoComprovante = JSON.parse(utilServices.normalizaBase64(response.data));
                    
                    if (retornoComprovante['RET'] == "1") {
                        utilServices.downloadBase64ToJpeg(utilServices.normalizaBase64(retornoComprovante['BASE64']), item['ID'] + retornoComprovante['EXT']);
                    } else
                        this.$bvToast.toast(response.data.OBJ[0].MSG, {title: "Erro", variant: "danger", solid: true,});
                })
                .catch((error) => {  
                    console.log(error);
                    
                    utilServices.parseServerError(error, this);
                })
                .finally(() => {
                    loader.hide();
                });
            },
            listar() {
                this.$insProgress.start();
                documentoServices.list()
                .then((response) => {
                    let retorno = response.data;
                    if (retorno['RET'] == "1") {
                        this.documentos = retorno['OBJ'];
                        this.totalizaValores();
                    } else {
                        utilServices.parseServerError(retorno['OBJ'][0]['MSG'], this);
                    }                
                })
                .catch((error) => {    
                    utilServices.parseServerError(error, this);
                })
                .finally(() => {
                    this.$insProgress.finish();
                });
            }
        }
    }
</script>